import { getRouteApi } from '@tanstack/react-router';

const mediaRouteApi = getRouteApi('/_authed/media');

export function useMediaRouteSearch() {
  return mediaRouteApi.useSearch();
}
